import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import { BondPreviewsAll } from "./BondPreviewsAll";
import { BondPreviewsClosed } from "./BondPreviewsClosed";
import { BondPreviewsOpen } from "./BondPreviewsOpen";

export const BondsView = () => {
	return (
		<EntityPreviewsLayout
			title="Bonds"
			storageKey="bonds_view"
			tabs={[
				{
					id: "all",
					label: "All",
					Component: BondPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					isDefault: true,
					Component: BondPreviewsOpen,
				},
				{
					id: "closed",
					label: "Closed",
					Component: BondPreviewsClosed,
				},
			]}
		/>
	);
};
